import { PARENT_SITE_ORIGIN } from '../constants/constants';

const sendMessage = (message: object) => {
    PARENT_SITE_ORIGIN.forEach((origin: string) => {
        if (!origin) {
            return;
        }
        try {
            parent.postMessage(message, origin);
        } catch (e) {
            console.error('Failed to send message', e);
        }
    });
};

// jobConfirmed mirrors `success`: it is the explicit "did the user approve the
// job?" flag Bluebox asked for. true  = user ticked approve + clicked Submit;
// false = user exited/cancelled without confirming. Both are terminal events —
// the portal only ever posts one of these per session, never on a timer.
export const sendExitMessage = () => {
    sendMessage({ success: false, jobConfirmed: false });
};

export const sendAddToOrderMessage = (data: object) => {
    sendMessage({ ...data, success: true, jobConfirmed: true });
};
